module.exports = __webpack_public_path__ + "img/tangible-investment.a30a6b92.svg";